module.exports = __webpack_public_path__ + "assets/img/icon (4).b42914d8.png";